import type { Reducer } from 'redux';

import type { DiagnosticsDebugLogsAction } from '../../domains/diagnosticsDebugLogs/actions.types';

import type { ErrorDebugLog, ErrorDebugLogPayload, ErrorDebugLogType, ErrorDebugLogs } from './types';

export const initialState: ErrorDebugLogs = {
  isLoggingEnabled: false,
  debugLogs: [],
};

let state = initialState;

type SetErrorDebugLogsState = (newState: ErrorDebugLogs) => void;
export const setErrorDebugLogsState: SetErrorDebugLogsState = (newState) => (state = newState);

type GetErrorDebugLogsState = () => ErrorDebugLogs;
export const getErrorDebugLogsState: GetErrorDebugLogsState = () => state;

type GetErrorDebugLogs = () => ErrorDebugLog[];
export const getErrorDebugLogs: GetErrorDebugLogs = () => state.debugLogs;

type AddErrorDebugLog = (
  state: ErrorDebugLogs,
  payload: ErrorDebugLogPayload,
  type: ErrorDebugLogType
) => ErrorDebugLog[];
const addErrorDebugLog: AddErrorDebugLog = (state, payload, type) => [
  ...state.debugLogs,
  {
    id: `${payload.name}_${new Date().getTime()}`,
    type,
    payload,
  },
];

export const reducer: Reducer<ErrorDebugLogs, DiagnosticsDebugLogsAction> = (state = initialState, action) => {
  if (!action || !action.type) {
    return state;
  }

  if (action.type === 'DIAGNOSTICS.SET_LOGGING_ENABLED') {
    return {
      ...state,
      isLoggingEnabled: action.payload,
    };
  }

  if (!state.isLoggingEnabled) {
    return state;
  }

  switch (action.type) {
    case 'DIAGNOSTICS.LOG_COMPONENT_ERROR':
      return {
        ...state,
        debugLogs: addErrorDebugLog(state, action.payload, 'Component'),
      };
    case 'DIAGNOSTICS.LOG_API_ERROR':
      return {
        ...state,
        debugLogs: addErrorDebugLog(state, action.payload, 'Api'),
      };
    case 'DIAGNOSTICS.CLEAR_ERROR_LOGS':
      return {
        ...state,
        debugLogs: [],
      };
    default:
      return state;
  }
};
